import React, {Component} from 'react'

export default class AdminColumnToggle extends Component {
  state = {
    menuOpen: false,
    columns: []
  }

  componentWillMount() {
    document.addEventListener('click', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false);
  }

  handleClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }
    this.handleClickOutside();
  }

  handleClickOutside = () => {
    this.setState({menuOpen: false});
  }

  onChange(e) {
    const options = this.state.columns
    if (!options) {
      return
    }
    let index

    if (e.target.checked) {
      options.push(e.target.value)
    } else {
      index = options.indexOf(e.target.value)
      options.splice(index, 1)
    }

    this.setState({options: options})

    this.props.onChange(options, this.props.alias);
  }

  dropdownToggle() {
    this.setState({menuOpen: !this.state.menuOpen, columns: this.props.checkedColumns});
    this.forceUpdate()
  }

  render() {
    const {
      columns,
      alias,
      icon,
      label
    } = this.props

    return (
        <div className="dropleft" ref={node => this.node = node}>
          <button type="button" className={"btn btn-secondary " + (this.state.menuOpen ? 'show' : '')}
                  aria-haspopup="true" onClick={() => this.dropdownToggle()}
                  aria-expanded="false">
            <i className={icon}></i>
          </button>
          <div className={"dropdown-menu px-3 " + (this.state.menuOpen ? 'show' : '')}>
            <h2>{label}</h2>
            <form>
              {columns && this.state.columns && this.state.columns.length > 0 && columns.map((value, index) => {
                return (
                    [
                      value.newColumnCategoryName &&
                      <div className="py-1" key={index + '-1'}>
                        <label className="category-label">{value.newColumnCategoryName}</label>
                      </div>,
                      <div className="py-1" key={index + '-2'}>
                        <input className="form-check-input inp-cbx" type="checkbox" style={{display: 'none'}}
                               value={value.name}
                               id={'#checkbox-' + alias + '-' + value.name} onChange={this.onChange.bind(this)}
                               defaultChecked={this.state.columns.indexOf(value.name) >= 0}/>
                        <label className="form-check-label cbx" htmlFor={'#checkbox-' + alias + '-' + value.name}><span>
    <svg width="12px" height="10px" viewBox="0 0 12 10">
      <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
    </svg></span><span>{value.label}</span></label>
                      </div>]
                )
              })}
            </form>
          </div>
        </div>
    )

  }
}
